import { render } from "./OrderProfile.vue?vue&type=template&id=399df899&scoped=true"
import script from "./OrderProfile.vue?vue&type=script&lang=js"
export * from "./OrderProfile.vue?vue&type=script&lang=js"

import "./OrderProfile.vue?vue&type=style&index=0&id=399df899&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399df899"]])

export default __exports__